import api from "@/services/api";
import type { VehicleDocumentCurrentResponse } from "../types";

export const getVehicleDocumentsCurrent = async (vehicleId: number) => {
	const { data } = await api.get<VehicleDocumentCurrentResponse>(
		`/api/vehicles/${vehicleId}/documents`
	);
	return data;
};
